'use client';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { ResetButton } from '@/components/ui/ResetButton/ResetButton';
import { Search } from '@/components/ui/form/Search/Search';
import s from './SearchLine.module.scss';

export const SearchLine = () => {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const { replace } = useRouter();

  const resetSearch = () => {
    const searchInput = document.getElementById('search-input') as HTMLInputElement | null;
    if (!searchInput) return;

    const params = new URLSearchParams(searchParams);

    searchInput.value = '';
    params.set('page', '1');
    params.delete('query');

    replace(`${pathname}?${params.toString()}`);
  };

  return (
    <div>
      <Search noCross />
      {searchParams.has('query') && <ResetButton onClick={resetSearch} className={s.resetButton} />}
    </div>
  );
};